import { MaterialPicker } from '../pickers/MaterialPicker';

/** GRN fix #5 — a Non-PO line is either a Material Master pick or a typed name (+ unit). */
export function NonPOItemInput({ line, onChange, testid = 'np-item', compact = true }) {
  const typed = line.item_mode === 'typed';
  const pickMaterial = (m) => onChange({ material_id: m?.id || '', description: m?.name || '', unit: m?.uom || line.unit || '', item_mode: 'master' });
  return (
    <div className="space-y-1" data-testid={testid}>
      {typed ? (
        <input value={line.description || ''} onChange={e => onChange({ description: e.target.value, material_id: '' })}
          placeholder="Item name, e.g. Binding wire 18G" data-testid={`${testid}-typed`}
          className={`w-full border rounded ${compact ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm'}`} />
      ) : (
        <MaterialPicker grouped={false} compact={compact} value={line.material_id} displayName={line.description}
          onSelect={pickMaterial} placeholder="Search material…" testid={`${testid}-material`} />
      )}
      <button type="button" data-testid={`${testid}-toggle`}
        onClick={() => onChange(typed ? { item_mode: 'master', material_id: '', description: '' } : { item_mode: 'typed', material_id: '' })}
        className="text-[10px] text-[#3b4872] hover:underline">
        {typed ? '← Pick from Material Master instead' : 'Not in list? Use typed name'}
      </button>
    </div>
  );
}
